import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
};

const instructionModule = {
  state,
  mutations,
  actions,
  getters,
};

export default instructionModule;
